import { render, staticRenderFns } from "./PostbackReport.vue?vue&type=template&id=447759f7&scoped=true"
import script from "./PostbackReport.vue?vue&type=script&lang=js"
export * from "./PostbackReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447759f7",
  null
  
)

export default component.exports